<template lang="pug">
  v-card.mx-auto(max-width='100%')
    v-snackbar(v-model='snackbar.snackbar' :color='snackbar.color' :center="true" :timeout='snackbar.timeout' :top="true")
      | {{ snackbar.text }}
      v-btn(dark='' text='' @click='snackbar.snackbar = false')
        | {{$t('payment.general.close')}}
    v-btn(fab small color="primary" @click="$emit('closeModalUserLocation')" style="position: absolute; z-index: 999; top: 10px; right: 0px;")
      v-icon.primary.rounded mdi-close
    v-card.mx-auto(max-width='344' outlined='')
      v-list-item(three-line='')
        v-list-item-content
          .overline.mb-4 UBICACIÓN
          label.headline.mb-1 {{txtAddress}}
        v-icon mdi-map-marker
    v-col(cols="12" md="12")
      gmap-autocomplete(@place_changed="setPlace" :options="autocompleteOptions" placeholder="Ingrese una ubicación" class="border-location" style="width: 100%; margin-top: 0px !important;").mt-7.location-input
    v-col(cols="12" md="12" style="padding: 0px 10px;")
      v-text-field(label="Título" required="" type="text" v-model="title")
    v-row
      v-col(cols="12" md="12" :style="isMobile ? 'max-height: 300px': ''")
        gmap-map(:center="center" :zoom="zoom" style="width:100%;  height: 500px;" :options="option")
          gmap-marker(:key="index" v-for="(m, index) in markers" :animation="2" :position="m.position" :clickable="true" @click="openInfoWindow(m)")
          gmap-info-window(:options="infoOptions" :opened="infoWinOpen" @closeclick="infoWinOpen=false")
    v-card-actions
      v-btn(color='#009da5'   :style="isMobile ? 'width: 100%; position: absolute; bottom: 0px;' : 'width: 100%;'" @click="saveUserLocation")
        | GUARDAR
</template>

<script>
  import * as vars from '@/vars.json'
  import Swal from 'sweetalert2'
  var geocoding = require('reverse-geocoding-google')
  export default {
    props: {
      currentPosition: null,
    },
    data () {
      return {
        snackbar: {
          color: '',
          snackbar: false,
          text: '',
          timeout: 6000,
        },
        txtAddress: '',
        title: '',
        zoom: 16,
        center: { lat: 37.0902405, lng: -95.7128906 },
        markers: [],
        option: {
          zoomControl: true,
          mapTypeControl: true,
          scaleControl: true,
          streetViewControl: true,
          rotateControl: true,
          fullscreenControl: true,
          disableDefaultUi: true,
        },
        infoOptions: {
          pixelOffset: {
            width: 0,
            height: -35,
          },
        },
        infoContent: {
          position: '',
          data: {
            location: '',
          },
        },
        autocompleteOptions: {
          componentRestrictions: {
            country: [
              'co',
            ],
          },
        },
        infoWinOpen: false,
      }
    },
    computed: {
      isMobile () {
        return window.innerWidth < 1024
      },
    },
    created () {
      this.geolocate()
      this.txtAddress = this.currentLocation
    },
    methods: {
      saveUserLocation () {
        if (this.title !== '') {
          const profile = this.$store.state.users.profile
          const arrLocations = profile.locations
          let arr = []
          if (arrLocations) {
            arr = Object.keys(arrLocations).map(location => {
              return { id: location, data: arrLocations[location] }
            })
          }
          for (let i = 0; i < arr.length; i++) {
            if (arr[i].data.location.lat === this.center.lat && arr[i].data.location.lng === this.center.lng) {
              this.setDataNotification(true, 'error', 'Dirección ya agregada.')
              return
            }
          }
          const location = {
            direction: this.txtAddress,
            title: this.title,
            location: this.center,
            id: '',
          }
          this.$store.dispatch('users/addUserLocation', location).then((res) => {
            if (res) {
              Swal.fire({
                title: 'Dirección agregada con éxito',
                icon: 'success',
              }).then(() => {
                this.$emit('closeModalUserLocation')
              })
            } else {
              this.setDataNotification(true, 'error', 'Error al momento de guardar la dirección.')
            }
          })
        } else {
          this.setDataNotification(true, 'error', 'Agregue el título de la dirección para continuar.')
        }
      },
      setDataNotification (ban, color, text) {
        this.snackbar.snackbar = ban
        this.snackbar.color = color
        this.snackbar.text = text
      },
      setPlace (place) {
        // console.log(place)
        this.txtAddress = place.formatted_address
        this.center = {
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng(),
        }
        this.markers = []
        this.markers.push({ position: this.center })
      },
      geolocate () {
        navigator.geolocation.getCurrentPosition(position => {
          this.center = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          }
          this.markers = []
          this.markers.push({ position: this.center })
          // gmapApi.geocoder.geo
          const config = {
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
            key: vars.googleKey,
          }
          geocoding.location(config, (err, data) => {
            if (err) {
              // console.log(err)
            } else {
              // console.log(data)
              this.txtAddress = data.results[0].formatted_address
            }
          })
        })
      },
    },
  }
</script>
